import { Box, DurationInput as GammaDurationInput } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'

type DurationInputProps = React.ComponentProps<typeof GammaDurationInput>

type Props = Omit<DurationInputProps, 'selectValue' | 'missingLabel' | 'locale'> & {
  missingLabel?: string
}

const DurationInput = ({ missingLabel, hoursDescription, minutesDescription, ...props }: Props) => (
  <Box className="DurationInput_root">
    <GammaDurationInput
      {...props}
      hoursDescription={hoursDescription ?? 'h'}
      minutesDescription={minutesDescription ?? 'mins'}
      missingLabel={missingLabel ?? i18n.t('common.missing_field')}
      selectValue={i18n.t('common.select')}
      locale={i18n.locale}
    />
  </Box>
)

export default DurationInput
